import { render, staticRenderFns } from "./OrderSubmit.vue?vue&type=template&id=90be33ac&scoped=true"
import script from "./OrderSubmit.vue?vue&type=script&lang=js"
export * from "./OrderSubmit.vue?vue&type=script&lang=js"
import style0 from "./OrderSubmit.vue?vue&type=style&index=0&id=90be33ac&prod&lang=less&scoped=true"
import style1 from "./OrderSubmit.vue?vue&type=style&index=1&id=90be33ac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90be33ac",
  null
  
)

export default component.exports